import { useCallback } from "react";

import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import useUiuxStore from "src/store/useUiuxStore";

import { useTQC1060_R01Store } from "./Store_TQC1060_R01";

interface EmployeeSearchResult {
	empNo?: string;
	empNm?: string;
}

export const Info_TQC1060_R01 = () => {
	const { setCodeSearchModalProps } = useUiuxStore();
	const {
		TQC1060_R01Info,
		setTQC1060_R01Info,
		selectedTQC1060_R01,
	} = useTQC1060_R01Store();

	const openEmployeeModal = useCallback(
		(field: "inspector" | "approvor") => {
			const isInspector = field === "inspector";
			setCodeSearchModalProps({
				category: isInspector ? "검사자" : "승인자",
				search: isInspector
					? TQC1060_R01Info.inspectorEmp
					: TQC1060_R01Info.approvorEmpno,
				formName: "TQC1060_R01",
				isInfo: true,
				handleFoucsId: isInspector
					? "tqc1060_inspectorEmp"
					: "tqc1060_approvorEmpno",
				wrapperOption: { size: "md", width: 50, overlay: true },
				onClear: () =>
					setTQC1060_R01Info(
						isInspector
							? { inspectorEmp: "", inspectorEmpNm: "" }
							: { approvorEmpno: "", approvorEmpNm: "" },
					),
				onConfirm: (data: EmployeeSearchResult) =>
					setTQC1060_R01Info(
						isInspector
							? { inspectorEmp: data.empNo || "", inspectorEmpNm: data.empNm || "" }
							: { approvorEmpno: data.empNo || "", approvorEmpNm: data.empNm || "" },
					),
			});
		},
		[setCodeSearchModalProps, setTQC1060_R01Info, TQC1060_R01Info],
	);

	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300 bg-white">
			<InputForm
				title="검사구분"
				name="inspectType"
				value="수입검사"
				editable={false}
			/>
			<InputForm
				title="거래처"
				name="customNm"
				value={selectedTQC1060_R01?.customNm ?? ""}
				editable={false}
			/>
			<InputForm
				title="품목"
				name="itemNm"
				value={selectedTQC1060_R01?.itemNm ?? ""}
				editable={false}
			/>
			<InputForm
				title="LotNo"
				name="lotNo"
				value={selectedTQC1060_R01?.lotNo ?? ""}
				editable={false}
			/>
			<BRDiv />
			<CodeForm
				label="검사자"
				name="inspectorEmp"
				value={TQC1060_R01Info.inspectorEmp}
				custNmValue={TQC1060_R01Info.inspectorEmpNm}
				handleFoucsId="tqc1060_inspectorEmp"
				handleChange={(event) =>
					setTQC1060_R01Info({ inspectorEmp: event.target.value })
				}
				onDoubleClick={() => openEmployeeModal("inspector")}
			/>
			<CodeForm
				label="승인자"
				name="approvorEmpno"
				value={TQC1060_R01Info.approvorEmpno}
				custNmValue={TQC1060_R01Info.approvorEmpNm}
				handleFoucsId="tqc1060_approvorEmpno"
				handleChange={(event) =>
					setTQC1060_R01Info({ approvorEmpno: event.target.value })
				}
				onDoubleClick={() => openEmployeeModal("approvor")}
			/>
		</div>
	);
};
